import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import Router from 'vue-router'
import axios from 'axios'
import momentFormat from './mixins/momentFormat'
import truncate from './mixins/truncate'
import {apiEnv,startDate,endDate} from './env.js'

var apiPath = apiEnv()
new Vue({
  el: "#Lineup",
  mixins: [momentFormat, truncate],
  data: {
    films: [],
    departments: [],
    hideFilter: true,
    filter: {
      page: 0,
      order_by: "department_id",
      departments: [],
      division_id: [],
      act_date: [],
      posts_per_page: 30
    },
    dates: []
  },
  components: {
    InfiniteLoading
  },
  methods: {
    searchFreeFlag(data) {
      for (var film of data) {
        if (film.acts.length && film.acts[0].is_show_flag_free) {
          film.is_free = true;
        }
      }
    },
    getSearch() {
      var q = window.location.href.split("?"),
        a,
        i,
        s,
        o;
      if (q.length > 1) {
        o = {};
        q = q[1];
        a = q.split("&");
        for (i = 0; i < a.length; i++) {
          s = a[i].split("=");
          if (
            s[0] == "act_date" ||
            s[0] == "departments" ||
            s[0] == "division_id"
          ) {
            this.filter[s[0]].push(
              decodeURIComponent(s[1].replace(/\+/g, " "))
            );
          } else {
            this.filter[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " "));
          }
        }
      }
      if (
        Object.keys(this.filter).length > 7 ||
        this.filter.departments.length > 0 ||
        this.filter.division_id.length > 0 ||
        this.filter.act_date.length > 0
      )
        this.hideFilter = false;
    },
    infiniteHandler($state) {
      this.filter.page++;
      var params = this.filter;
      axios
        .get(apiPath + "/films/search", { params })
        .then(res => {
          if (res.data.data.length) {
            console.log(res);
            this.films = this.films.concat(res.data.data);
            $state.loaded();
            if (res.data.current_page == res.data.last_page) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created () {
    for (var i = 0; i <= this.daysDiff(startDate, endDate);i++){
     this.dates.push(this.addDays(startDate,i))
    }
  },
  mounted() {
    this.getSearch();
    axios.get(apiPath + "/departments").then(res => {
      this.departments = res.data;
    });
  }
});



// WEBPACK FOOTER //
// ./src/list.js